export const Regexes = {
  // DEFAULT_EMAIL_REGEX : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  DEFAULT_EMAIL_REGEX : /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export const Errors = {
  IS_REQUIRED:  'Is Required!',
  AT_LEAST_THREE: 'At least 3 characters!',
  AT_LEAST_PASSWORD: 'At least 6 characters!',
  INVALID: 'Is Invalid!'
};

export const ValidationTypes = {
  USERNAME_TYPE: 'username',
  PASSWORD_TYPE: 'password',
  EMAIL_TYPE: 'email',
  SELECT_TYPE: 'select',
  IS_REQUIRED: 'required'
};